/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-09-14 09:37:13
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-16 17:43:33
 */
/*
 * title
 *
 *
 */

export default {
  name: 'card-items-report',
  props: {
    item: {
      default: () => { }
    }
  },
  render(h) {
    const { item, $dataCheck } = this
    console.log(item);
    return (
      <div class="box-item ">
        <div class="box">
          <div class="text">
            {item.visible ? (
              <el-tooltip
                appendToBody={false}
                popperOptions={{ boundariesElement: item.tipTargetElemnt, gpuAcceleration: true }}
                manual
                value={item.visible}
                class="popover-pos"
                placement="top-start"
              >
                <div class="info-tooltip-card" slot="content">
                  {item.tip && item.tip(h, item)}
                  <el-button
                    type="text"
                    icon="el-icon-close"
                    onClick={() => item.tipCallback(item)}
                    size="mini"
                  ></el-button>
                </div>
                <span>
                  {$dataCheck(item.title)}
                  {item.currency && `(${item.currency})`}
                </span>
              </el-tooltip>
            ) : (
              <span>
                {$dataCheck(item.title)}
                {item.currency && <span>({item.currency})</span>}
              </span>
            )}
            {item.tooltip && (
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">
                  <div>{item.tooltip}</div>
                </div>
                <i class="icon-a-01wenhao iconfont-el icon" />
              </el-tooltip>
            )}
          </div>
          {item.tip ? (
            item.tipCallback ? (
              <div class="number font-manrope">{$dataCheck(item.number, 0)}</div>
            ) : (
              <el-popover placement="bottom-start" trigger="hover">
                <div class="card-content__popover">{item.tip && item.tip(h, item)}</div>
                <div class="number font-manrope" slot="reference">
                  {$dataCheck(item.number, 0)}
                </div>
              </el-popover>
            )
          ) : (
            <div class="number font-manrope">{$dataCheck(item.number, 0)}</div>
          )}

          <span style={item.rate < 0 ? 'color:#00ce47' : ''} class="rate">
            <span class="font-manrope">{$dataCheck(item.rate)}</span>%
            {item.rate < 0 ? (
              <i class="iconfont iconChevron-Top" style="transform: rotate(180deg);color: #00ce47" />
            ) : (
              <i class="iconfont iconChevron-Top" />
            )}
          </span>
        </div>
        {(item.icon || item.img) && <div class="box-img">
          {item.img && <img src={item.img} />}
          {item.icon && <i class={`iconfont ${item.icon}`} />}
        </div>}
      </div>
    )
  }
}
